<template>
  <div id="structures">
    <VueDraggable
      :model-value="structureTypes"
      class="grid grid-cols-2 justify-center gap-2 px-2.5 pt-4"
      :animation="150"
      :group="draggableOptions.group"
      :sort="draggableOptions.sort"
    >
      <Structure
        v-for="structureType in structureTypes"
        :key="structureType"
        class=""
        :type="structureType"
        :data-testid="`structure-${structureType}`"
        :data-cols="structureType"
      ></Structure>
    </VueDraggable>
  </div>
</template>
<script setup lang="ts">
  import { VueDraggable } from "vue-draggable-plus";
  import Structure from "./_internal/Structure/Structure.vue";

  const draggableOptions = {
    group: { name: "sections", pull: "clone" as const, put: false },
    sort: false,
  };

  const structureTypes = [
    "100",
    "50-50",
    "33.33-33.33-33.33",
    "25-25-25-25",
    "40-60",
    "60-40",
    "25-75",
    "75-25",
    "25-25-50",
    "50-25-25",
  ];
</script>
